import * as React from 'react'

import { TypographySpan } from '@/components/ui/typography'
import { cn } from '@/lib/utils'

export type MarketingModulePreTitleProps = Omit<
  React.ComponentProps<typeof TypographySpan>,
  'variant'
>

export function MarketingModulePreTitle({ className, ...props }: MarketingModulePreTitleProps) {
  return (
    <TypographySpan
      variant="eyebrow"
      className={cn('mb-3 block font-mono text-fs-md font-bold uppercase tracking-widest', className)}
      {...props}
    />
  )
}
